export class DownloadTabs {
    static setPlatformName(tabName: string | undefined) {
        const platformName: HTMLElement | null = document.querySelector('[data-download-platform-name]');
        if (platformName && tabName) {
            platformName.innerText = tabName;
        }
    }
}
